import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import coffe from "../../Assets/Projects/4.png";
import anime from "../../Assets/Projects/5.png";
import addict from "../../Assets/Projects/2.png";
import word from "../../Assets/Projects/1.png";
import quizz from "../../Assets/Projects/3.png";

function Projects() {
  return (
    <Container fluid className='project-section'>
      <Particle />
      <Container>
        <h1 className='project-heading'>
          My Recent <strong className='purple'>Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className='project-card'>
            <ProjectCard
              imgPath={coffe}
              isBlog={false}
              title='Coffe Booking App'
              description='User can select type of coffe through App can order the coffe.'
              link='https://github.com/iammeet071/CoffeBookingApp-Flutter'
            />
          </Col>

          <Col md={4} className='project-card'>
            <ProjectCard
              imgPath={addict}
              isBlog={false}
              title='Pneumonia Detection and Addiction Tracker'
              description='Pneumonia Detection and Addiction Tracker using Flutter, Django, ML models.'
              link='https://github.com/iammeet071/Pneumonia-Detection-and-Addiction-Tracker'
            />
          </Col>

          <Col md={4} className='project-card'>
            <ProjectCard
              imgPath={word}
              isBlog={false}
              title='World Clock App'
              description='The Apps shows the time of different countries, using World CLock Api and Flutter.'
              link='https://github.com/iammeet071/WorldClockAppApi-FLutter'
            />
          </Col>

          <Col md={4} className='project-card'>
            <ProjectCard
              imgPath={anime}
              isBlog={false}
              title='Anime Netflix Series Website'
              description='Built a website through which user can watch Top netflix anime series, it is created using React.Js'
              link='https://github.com/iammeet071/NetflixSeriesCards-React'
            />
          </Col>

          <Col md={4} className='project-card'>
            <ProjectCard
              imgPath={quizz}
              isBlog={false}
              title='Quizz App'
              description='Created a Quizz App using Flutter'
              link='https://github.com/iammeet071/QuizzApp-Flutter'
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
